type IntegrationImageProps = {
  integrationName: string;
};
const IntegrationImage = ({
  integrationName,
  ...other
}: IntegrationImageProps &
  React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) => {
  return (
    <img
      {...other}
      style={{ objectFit: 'scale-down', maxHeight: '100%', ...other.style }}
      src={integrationName}
      alt=""
    />
  );
};

export default IntegrationImage;
